import { render, staticRenderFns } from "./FeatureCardBasic.vue?vue&type=template&id=5d3ee539&scoped=true&"
import script from "./FeatureCardBasic.vue?vue&type=script&lang=js&"
export * from "./FeatureCardBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ee539",
  null
  
)

export default component.exports